
const SearchResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	"searchKey": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"pricedItineraries": [
		{
			"provider": 0,
			"providerName": "string",
			"providerOwner": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
			"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
			"id": "string",
			"company": "string",
			"operatingCompany": {
				"code": "string",
				"name": "string"
			},
			"boardingPoint": {
				"city": "string",
				"terminal": "string",
				"additionalInfo": {
					"city": {
						"id": "string",
						"name": "string",
						"englishName": "string"
					},
					"name": "string",
					"englishName": "string"
				}
			},
			"droppingPoints": [
				{
					"city": "string",
					"terminal": "string",
					"additionalInfo": {
						"city": {
							"id": "string",
							"name": "string",
							"englishName": "string"
						},
						"name": "string",
						"englishName": "string"
					}
				}
			],
			"type": "string",
			"price": 0,
			"financial": {
				"price": 0,
				"maxApplicableDiscountPercentage": 0,
				"availablePaymentMethods": [
					"string"
				],
				"commissionPercentage": 0
			},
			"departureDate": "string",
			"availableSeates": 0,
			"status": "string",
			"description": "string",
			"fromCityCode": "string",
			"fromCityName": "string",
			"toCityCode": "string",
			"toCityName": "string",
			"date": "string",
			"transferCode": "string",
			"imageURL": "string",
			"transferCompanyID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
		}
	]
};
 

  export default SearchResponse;
  